import { Contract } from '@/gql/graphql';

export function isContractActive({ date, finishDate }: Pick<Contract, 'date' | 'finishDate'>) {
  const startDate = date ? new Date(date).getTime() : Number.MIN_SAFE_INTEGER;
  const endDate = finishDate ? new Date(finishDate).getTime() : Number.MAX_SAFE_INTEGER;

  const currentTimestamp = new Date().getTime();

  return startDate <= currentTimestamp && currentTimestamp < endDate;
}
